type ZIndexInput<T> = T | [T, number];

type ZIndexValues<T extends string> = { [key in T]: number };

const genZIndexValues = <T extends string>(...names: ZIndexInput<T>[]): ZIndexValues<T> => {
  const values = {} as ZIndexValues<T>;

  // The first item in the list should have a `z-index` of 2 because we
  // sometimes use `z-index: 1` explicitly for some elements, and we want
  // the generated `z-index` values to be above those elements.
  let lastValue = 1;

  names.forEach((nameOrNameWithValue) => {
    const [name, value] = Array.isArray(nameOrNameWithValue)
      ? nameOrNameWithValue
      : [nameOrNameWithValue, lastValue + 1];

    values[name] = value;
    lastValue = value;
  });

  return values;
};

export default genZIndexValues;
